

const open  = () => true;
const close = () => false;

export { open, close }